export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6776.89d42673.jpg";